"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTheme = void 0;
var _react = require("react");
var _context = require("./context");
var _ = require(".");
var _logService = require("../tools/service/log/logService");
var useTheme = exports.useTheme = function useTheme() {
  var name = _.Theme.DEFAULT;
  try {
    var _useContext = (0, _react.useContext)(_context.ThemeContext),
      contextTheme = _useContext.name;
    name = contextTheme;
  } catch (e) {
    (0, _logService.logSpecificErrorMessage)('useTheme', e);
  }
  return {
    name: name
  };
};